// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ME0B","type":"styles_type__3Oq5C","choices":"styles_choices__1lgAe"};